var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMaterial = function SvgMaterial(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.332 25.667-3.08-12a7.92 7.92 0 0 0 1.747-5 8 8 0 0 0-16 0 7.92 7.92 0 0 0 1.787 5.027L.666 25.667a1.333 1.333 0 0 0 1.973 1.48l7.107-4.173 7.573 4.186c.205.124.441.184.68.174a1.334 1.334 0 0 0 1.333-1.667ZM10 3.334A5.333 5.333 0 1 1 10 14a5.333 5.333 0 0 1 0-10.666Zm.413 16.946a1.334 1.334 0 0 0-1.333 0l-5 2.934 1.92-7.6a7.92 7.92 0 0 0 7.893 0l2.04 7.72-5.52-3.054Z"
  })));
};
export default SvgMaterial;